import { signupFormSchema } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import { DEFAULT_REDO_OVERLAY_Z_INDEX } from "@redotech/redo-web/shopify/shopify-z-index";
import { createRoot } from "react-dom/client";
import { RedoShopifyRpcClientContextProvider } from "../client/redo-shopify-rpc-client";
import { RedoStorefrontContainer } from "../redo-storefront/redo-storefront-container";
import "../styles.css";
import { SignupFormInstanceWrapper } from "./signup-form-instance-wrapper";

const REDO_MARKETING_POPUP_FORM_CONTAINER_ID =
  "redo-marketing-popup-form-container"; // referenced in "./styles.global.css"

export function initialize(autocheck: WidgetAutocheck) {
  if (globalThis.blockRedo) {
    return;
  }

  if (document.getElementById(REDO_MARKETING_POPUP_FORM_CONTAINER_ID)) {
    return;
  }

  // Create
  const redoContainer = document.createElement("div");
  redoContainer.id = REDO_MARKETING_POPUP_FORM_CONTAINER_ID;
  redoContainer.style.zIndex = `${DEFAULT_REDO_OVERLAY_Z_INDEX}`;
  // Force display to prevent merchant CSS rules like "div:empty { display: none; }" from hiding the container
  redoContainer.style.display = "block";
  document.body.append(redoContainer);

  const root = createRoot(redoContainer);

  const queryParameters = new URLSearchParams(location.search);
  const forceId = queryParameters.get("signup-form-id") || undefined;
  const parsedForceForm = (() => {
    const forceForm = queryParameters.get("signup-form-object") || undefined;

    const forcedFormParseResult = forceForm
      ? signupFormSchema.safeParse(JSON.parse(forceForm))
      : undefined;
    if (forcedFormParseResult && !forcedFormParseResult?.success) {
      console.error("Failed to parse forced form", forcedFormParseResult.error);
    }
    return forcedFormParseResult?.success
      ? forcedFormParseResult.data
      : undefined;
  })();
  const utmParams = (() => {
    const utmParamPrefix = "_shopify_sa_p=";
    const cookies = document.cookie.split(";");
    const utmParamsCookie = cookies.find((cookie) =>
      cookie.trim().startsWith(utmParamPrefix),
    );
    return utmParamsCookie
      ? decodeURIComponent(utmParamsCookie.substring(utmParamPrefix.length + 1))
      : "";
  })();

  root.render(
    <RedoStorefrontContainer container={redoContainer}>
      <RedoShopifyRpcClientContextProvider
        baseUrl={
          globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
          process.env.REDO_SHOPIFY_SERVER_URL!
        }
        storeUrl={
          globalThis.redoStorefront?.storeUrl ??
          globalThis.Shopify?.shop ??
          globalThis.Shopify?.Checkout?.apiHost
        }
        widgetId={globalThis.redoWidgetId}
      >
        <SignupFormInstanceWrapper
          brandKit={autocheck.brandKit}
          forceForm={parsedForceForm}
          forceId={forceId}
          utmParams={utmParams}
        />
      </RedoShopifyRpcClientContextProvider>
    </RedoStorefrontContainer>,
  );
}
